Whether verification with SEEK Pass is now enabled for this hirer-partner combination.
